/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GearSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128.00293}
        cy={128.00195}
        r={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M197.40822,80.65057a83.91167,83.91167,0,0,1,6.28743,10.91L229.64192,105.964a103.88962,103.88962,0,0,1,.03183,44.05764L203.71308,164.433a83.9121,83.9121,0,0,1-6.30467,10.90011l.49944,29.67182a103.88955,103.88955,0,0,1-38.13913,22.05638l-25.46093-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26885,227.04288A103.88987,103.88987,0,0,1,58.0979,205.04162l.49974-29.68828a83.91167,83.91167,0,0,1-6.28743-10.91005L26.36394,150.0399a103.88946,103.88946,0,0,1-.03183-44.05764L52.29278,91.5709a83.91132,83.91132,0,0,1,6.30467-10.9001L58.098,50.999A103.88969,103.88969,0,0,1,96.23714,28.94259l25.46093,15.27693a83.91075,83.91075,0,0,1,12.5921.00995L159.737,28.961a103.88959,103.88959,0,0,1,38.171,22.00126Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default GearSix;
